(function () {
  'use strict';

  var TRACK_SELECTORS = [
    '.plz-ann__track',
    '.plz-shop-marquee__track',
    '.plz-amb-marquee__track',
    '.plz-hgr-ticker__track',
  ].join(',');

  function readUnitNodes(track) {
    if (track.dataset.plzMarqueeSeed) {
      var seed = document.createElement('div');
      seed.innerHTML = track.dataset.plzMarqueeSeed;
      return Array.from(seed.children);
    }

    var nodes = Array.from(track.children).filter(function (node) {
      return !node.classList.contains('plz-marquee__group');
    });

    if (!nodes.length) return [];

    var unitCount = parseInt(track.dataset.plzMarqueeUnit || '', 10);
    if (!unitCount || unitCount < 1 || unitCount > nodes.length) {
      unitCount = nodes.length;
    }

    return nodes.slice(0, unitCount).map(function (node) {
      return node.cloneNode(true);
    });
  }

  function storeSeed(track, unitNodes) {
    if (track.dataset.plzMarqueeSeed || !unitNodes.length) return;
    var seed = document.createElement('div');
    unitNodes.forEach(function (node) {
      seed.appendChild(node);
    });
    track.dataset.plzMarqueeSeed = seed.innerHTML;
  }

  function buildGroup(unitNodes) {
    var group = document.createElement('div');
    group.className = 'plz-marquee__group';
    unitNodes.forEach(function (node) {
      group.appendChild(node.cloneNode(true));
    });
    return group;
  }

  function fillGroup(group, unitNodes, minWidth) {
    var guard = 0;
    while (group.scrollWidth < minWidth && guard < 40) {
      unitNodes.forEach(function (node) {
        group.appendChild(node.cloneNode(true));
      });
      guard += 1;
    }
  }

  function initTrack(track) {
    var parent = track.closest('.plz-ann, .plz-shop-marquee, .plz-amb-marquee__viewport, .plz-hgr-ticker');
    if (!parent) return;

    var unitNodes = readUnitNodes(track);
    if (!unitNodes.length) return;

    storeSeed(track, unitNodes);

    var minGroupWidth = Math.max(parent.clientWidth, window.innerWidth) * 1.05;

    track.textContent = '';
    track.classList.add('plz-marquee__track--ready');

    var groupA = buildGroup(unitNodes);
    track.appendChild(groupA);
    fillGroup(groupA, unitNodes, minGroupWidth);

    var groupB = groupA.cloneNode(true);
    groupB.setAttribute('aria-hidden', 'true');
    track.appendChild(groupB);
  }

  function initAll() {
    document.querySelectorAll(TRACK_SELECTORS).forEach(initTrack);
  }

  function boot() {
    initAll();

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(initAll, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
